<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { getColor, getColorByLightness, personalizeText } from '$lib/helper';

    import Color from 'color';
    import get from 'lodash/get';

    import PaymentFormView from './PaymentForm.View.svelte';

    import type {
        Currency,
        PaymentFormContent,
    } from '$lib/types/Components/PaymentForm/PaymentFormContent';
    import type { Language } from '$lib/types/Language';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';

    export let id = '';
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let layout = DEFAULT_LAYOUT;
    export let content: PaymentFormContent;
    export let theme: Theme;
    export let trackingProperties: TrackingProperty[] = [];
    export let campaignId = '';
    export let campaignVersionId = '';
    export let nextPage = '';
    export let firstResultPage = '';

    export let language: Language = 'en';

    const CURRENCY_SYMBOL_MAP: Record<Currency, string> = {
        eur: '€',
        usd: '$',
        gbp: '£',
        chf: 'CHF',
    };

    // Text
    const draft = personalizeText(content.wysiwyg, trackingProperties, campaignId, language);

    // Button
    const { currency, amountInText } = content;
    const currencySymbol = currency ? CURRENCY_SYMBOL_MAP[currency] : '';
    const btnText =
        language === 'en'
            ? `Pay ${currencySymbol} ${amountInText} now`
            : `Jetzt ${amountInText} ${currencySymbol} zahlen`;

    const btnBgColor = theme.buttonBackgroundColor;
    const btnBgColorDark = Color(btnBgColor).darken(0.1);
    const btnColor = getColorByLightness(btnBgColor);

    const regularNextPage = get(content, 'linking.pageId', nextPage);
    const externalLink = get(content, 'linking.url', '');
    const isInternal = content.linking?.isInternal ?? true;
    const linkingComponentId = get(content, 'linking.componentId', '');
</script>

<PaymentFormView
    box={content.box}
    paymentConfigId={content.paymentConfigId}
    color={getColor(content.color, theme.fontColor)}
    {id}
    {nextPage}
    {firstResultPage}
    {regularNextPage}
    {externalLink}
    {isInternal}
    {campaignId}
    {campaignVersionId}
    {draft}
    {transitionDelay}
    {transitionEffect}
    {layout}
    {btnBgColor}
    {btnBgColorDark}
    {btnColor}
    {btnText}
    {language}
    {linkingComponentId}
/>
